import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { License } from 'src/app/models/licenses-model/license.model';
import { LicensesService } from 'src/app/services/licenses-service/licenses.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-licenses-licenses-breadcrumb-filter',
  templateUrl: './licenses-licenses-breadcrumb-filter.component.html',
  styleUrls: ['./licenses-licenses-breadcrumb-filter.component.scss']
})
export class LicensesLicensesBreadcrumbFilterComponent implements OnInit {

  @Input() licenses: License[];
  centers;
  types;
  models;
  apps;
  centersForm = new FormGroup({});
  typesForm = new FormGroup({});
  modelsForm = new FormGroup({});
  appsForm = new FormGroup({});

  constructor(private userStorageService: UserStorageService,
              private licensesService: LicensesService) { }

  ngOnInit() {
    this.getCenters();
    this.getTypes();
    this.getModels();
    this.getApps();
    if (this.userStorageService.getFilterLicenses()) {
      this.centersForm.patchValue(this.userStorageService.getFilterLicenses()['centersForm']);
      this.typesForm.patchValue(this.userStorageService.getFilterLicenses()['typesForm']);
      this.modelsForm.patchValue(this.userStorageService.getFilterLicenses()['modelsForm']);
      this.appsForm.patchValue(this.userStorageService.getFilterLicenses()['appsForm']);
    }
    this.filter();
  }

  public updateCheckbox(form, reset?) {
    this._toggleCheckboxes(form, reset);
  }

  private _toggleCheckboxes(form, reset) {
    if (reset && form.get('all').value) {
      Object.entries(form.controls).forEach(c => (c[0] !== 'all') ? (c[1] as FormControl).setValue(false) : null);
    } else if (Object.entries(form.controls).find(c => (c[0] !== 'all') && (c[1] as FormControl).value)) {
      form.get('all').setValue(false);
    } else if (!Object.entries(form.controls).find(c => (c[1] as FormControl).value)) {
      form.get('all').setValue(true);
    }
    this.userStorageService.setFilterLicenses({
      centersForm: this.centersForm.getRawValue(),
      typesForm: this.typesForm.getRawValue(),
      modelsForm: this.modelsForm.getRawValue(),
      appsForm: this.appsForm.getRawValue()
    });
    if (this.userStorageService.getFilterLicenses()['centersForm']['all'] &&
      this.userStorageService.getFilterLicenses()['typesForm']['all'] &&
      this.userStorageService.getFilterLicenses()['modelsForm']['all'] &&
      this.userStorageService.getFilterLicenses()['appsForm']['all']) {
      this.userStorageService.deleteFilterLicenses();
    }
    this.filter();
  }

  private getCenters() {
    const centers = new Array<string>();
    this.centersForm.addControl('all', new FormControl(true));
    this.licenses.forEach((license: License) => {
      this.addOption(centers, this.centersForm, license.CenterName);
      (license.DeviceList || []).forEach(device => this.addOption(centers, this.centersForm, device.CenterName));
    });
    this.centers = centers;
  }

  private getTypes() {
    const types = new Array<string>();
    this.typesForm.addControl('all', new FormControl(true));
    this.licenses.forEach((license: License) => {
      (license.DeviceList || []).forEach(device => this.addOption(types, this.typesForm, device.DeviceTypeName));
    });
    this.types = types;
  }

  private getModels() {
    const models = new Array<string>();
    this.modelsForm.addControl('all', new FormControl(true));
    this.licenses.forEach((license: License) => {
      (license.DeviceList || []).forEach(device => this.addOption(models, this.modelsForm, device.DeviceModel));
    });
    this.models = models;
  }

  private getApps() {
    const apps = new Array<string>();
    this.appsForm.addControl('all', new FormControl(true));
    this.licenses.forEach((license: License) => {
      this.addOption(apps, this.appsForm, license.AppName);
    });
    this.apps = apps;
  }

  private addOption(options: string[], form: FormGroup, option: string) {
    if (option && options.indexOf(option) === -1) {
      options.push(option);
      form.addControl(option, new FormControl(false));
    }
  }

  public filter() {
    this.licensesService.filterLicenses({
      centers: this.getSelectedValues(this.centersForm),
      types: this.getSelectedValues(this.typesForm),
      models: this.getSelectedValues(this.modelsForm),
      apps: this.getSelectedValues(this.appsForm)
    });
  }

  private getSelectedValues(form: FormGroup) {
    if (form.get('all').value) {
      return null;
    }
    const values = [];
    Object.entries(form.value).forEach(c => { if (c[1]) { values.push(c[0]); }});
    return values;
  }
}
